import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POIJobPostingEditDialog from "@/components/POI/POIJobPostingEditDialog/POIJobPostingEditDialog.vue";
import cloneDeep from "lodash/cloneDeep";
import { close } from "@sentry/vue";

const defaultJobPosting = {
  title: "",
  description: "",
  logo: {
    url: "",
    originalUrl: ""
  },
  features: []
};

export default {
  name: "POIJobPostings",
  components: {
    POIJobPostingEditDialog,
    POIStep
  },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    headers: [
      { text: "Titel", value: "title", sortable: false },
      { text: "Aktionen", value: "actions", sortable: false }
    ],
    itemsPerPage: 10,
    pageCount: 0,
    page: 1,
    jobPostingEditDialog: false,
    editedJobPostingIndex: -1,
    editedJobPosting: {},
    mainPeacock: "#00636C"
  }),
  methods: {
    close,
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    addJobPosting() {
      this.editedItem.jobPostings.push(cloneDeep(defaultJobPosting));
      const index = this.editedItem.jobPostings.length - 1;
      this.editJobPosting(this.editedItem.jobPostings[index], index);
    },
    removeJobPosting(index) {
      if (index < 0) return;
      this.editedItem.jobPostings.splice(index, 1);
    },
    editJobPosting(jobPosting, index) {
      if (index < 0) return;
      this.editedJobPostingIndex = index;
      this.editedJobPosting = cloneDeep(jobPosting);
      this.jobPostingEditDialog = true;
    },
    closeJobPostingEdit(jobPosting) {
      if (jobPosting) {
        this.editedItem.jobPostings[this.editedJobPostingIndex] = cloneDeep(
          jobPosting
        );
        this.editedItem.jobPostings.reverse().reverse();
      }
      this.jobPostingEditDialog = false;
      this.editedJobPostingIndex = -1;
      this.editedJobPosting = {};
    },
    moveUp(array, element) {
      this.move(array, element, -1);
    },
    moveDown(array, element) {
      this.move(array, element, 1);
    },
    move(array, element, delta) {
      const index = array.indexOf(element);
      const newIndex = index + delta;
      if (newIndex < 0 || newIndex === array.length) {
        return;
      }
      const indexes = [index, newIndex];
      indexes.sort();
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
    },
    nextPage() {
      const total = this.jobPostingsCount;
      const perPage = this.itemsPerPage;
      const totalPages = Math.ceil(total / perPage);

      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  },
  computed: {
    isReadOnly() {
      return this.isOwnedBySubPrincipal;
    },
    jobPostingsCount() {
      return this.editedItem.jobPostings?.length ?? 0;
    }
  }
};
